import React from "react";
import PropTypes from "prop-types";
import { GlassContainer } from "./Glass.Style";
import { resolveClassNames } from "../../../utils";

const Glass = (props) => {
  const { show, className: propsClassName } = props;

  const className = resolveClassNames(propsClassName, show ? "active" : "");

  return <GlassContainer {...props} className={className} />;
};

Glass.defaultProps = {
  show: false,
  glassOpacity: 0.9,
};

Glass.propTypes = {
  show: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  glassOpacity: PropTypes.number,
};

export default Glass;
